<div class="wrapper">
  <div class="title">{{ name }}</div>
  <hr class="horizontalLine" [style.background]="horizontalLineBackground"/>

  <div class="contentContainer">

    <div class="musicCollectionsContainer">
      @if (musicCollections != null) {
        @for (musicCollection of musicCollections; track musicCollection) {
          <tun-search-music-collection-large-button-view
            class="musicCollection"
            [musicCollection]="musicCollection"
            [hexColor]="hexColor"
            (showDetails)="onShowDetails($event)"
            >
          </tun-search-music-collection-large-button-view>
        }
      }

    </div>

  </div>

</div>
